function SubscriptionsMgmt() {
    return ('SubscriptionsMgmt');
}

export default SubscriptionsMgmt;
